export default "__VITE_ASSET__nbSoRT_y__"